import {useCallback, useEffect, useState, ChangeEvent} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import debounce from 'lodash.debounce';
import url from 'url';
import {
  fieldLengthLimit,
  firstPage,
  validationRegex
} from '../../constants/constants';
import {Button} from './Button';
import {QueryParamsProps, ListEntityType} from '../../constants/types';
import EnsurePermissions from './EnsurePermission';
import {FormGroup, TextField} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';

type SearchProps = {
  entity: ListEntityType,
  query: QueryParamsProps
}

const debounceDelay = 1200;

export const ListSearch = ({
  entity,
  query
}: SearchProps) => {
  const {pathname} = useLocation();
  const {simple_search: simpleSearch = ''} = query || {};

  const history = useHistory();
  const [searchValue, setSearchValue] = useState(simpleSearch || '');

  useEffect(() => {
    setSearchValue(simpleSearch);
  }, [simpleSearch]);

  const goToAddPage = () => {
    history.push(`${location.pathname}/add`);
  };

  const handleInputChange = (
      event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    let inputValue = event.target.value;

    if (validationRegex.test(inputValue)) {
      return;
    }

    if (inputValue.length > fieldLengthLimit) {
      inputValue = inputValue.substring(0, fieldLengthLimit);
    }

    getDebouncedSearchResult(query, inputValue);
    setSearchValue(inputValue);
  };

  const getDebouncedSearchResult =
    useCallback(debounce((savedQuery: QueryParamsProps, value: string) => {
      history.push(
          url.format({
            pathname,
            query: {...savedQuery, simple_search: value, page: firstPage}
          })
      );
    }, debounceDelay), []);

  return (
    <div className="search-container">
      <FormGroup className="searchbar">
        <TextField
          size="small"
          variant="outlined"
          className="searchbar__input"
          type="text"
          name="searchbar"
          label="Search"
          value={searchValue}
          onChange={(event) => {
            handleInputChange(event);
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon className="searchbar__icon" />
              </InputAdornment>
            )
          }}
        />
      </FormGroup>

      {entity?.buttonLabel && (
        <EnsurePermissions elementPermissions={entity.permissions}>
          <Button
            label={entity.buttonLabel || ''}
            onClick={goToAddPage}
            variant="contained"
            color="primary"
            className="new-entity-button"
          />
        </EnsurePermissions>
      )}
    </div>
  );
};
